import React from 'react';
import {
  ADD_MSISDNS,
  ADD_MSISDNS_FROM_CONTACTS,
  ADD_MSISDNS_FROM_FILE,
  ADD_MSISDNS_FROM_GROUPS,
  PREVIEW_CAMPAIGN,
  SHOW_MSISDNS
} from '../../../config/constants';
import AddMsisdns from '../AddMsisdns';
import AddMsisdnsFromContacts from '../AddMsisdnsFromContacts';
import AddMsisdnsFromGroups from '../AddMsisdnsFromGroups';
import AddMsisdnsFromFile from '../AddMsisdnsFromFile';
import ShowMsisdns from '../ShowMsisdns';
import CampaignPreview from '../CampaignPreview';

const renderModalForm = function(modalName) {
  const { lang, addNotification } = this.props;
  const {
    PAYLOAD,
    errorMessage,
    isEdit,
    createDraftCampaignsIsLoading,
    createDraftCampaignsError,
    createAndSendCampaignsIsLoading,
    createAndSendCampaignsError,
    sendCampaignsIsLoading,
    sendCampaignsError,
    updateDraftCampaignsIsLoading,
    updateDraftCampaignsError
  } = this.state;

  const addMsisdnsWrapper = (WrapperComponent) => {
    return(
      <WrapperComponent
        lang={lang}
        updateMsisdns={this.updateMsisdns}
        hideDrawer={this.hideDrawer}
      />
    );
  };

  const { name, msisdns } = PAYLOAD;

  switch (modalName) {
    case ADD_MSISDNS: return addMsisdnsWrapper(AddMsisdns);
    case ADD_MSISDNS_FROM_CONTACTS: return addMsisdnsWrapper(AddMsisdnsFromContacts);
    case ADD_MSISDNS_FROM_GROUPS: return addMsisdnsWrapper(AddMsisdnsFromGroups);
    case ADD_MSISDNS_FROM_FILE:
      return (
        <AddMsisdnsFromFile
          lang={lang}
          updateMsisdns={this.updateMsisdns}
          hideDrawer={this.hideDrawer}
          updateSmsBodyMeta={this.updateSmsBodyMeta}
        />
      );
    case SHOW_MSISDNS:
      return (
        <ShowMsisdns
          lang={lang}
          name={name}
          msisdns={msisdns}
          substituteMsisdns={this.substituteMsisdns}
          hideDrawer={this.hideDrawer}
        />
      );
    case PREVIEW_CAMPAIGN:
      return (
        <CampaignPreview
          errorMessage={errorMessage}
          toAllCampaigns={this.toAllCampaigns}
          lang={lang}
          msisdns={msisdns}
          previewData={PAYLOAD}
          isEdit={isEdit}
          sendCampaign={this.sendCampaign}
          sendCampaignsIsLoading={sendCampaignsIsLoading}
          sendDraftCampaignsError={sendCampaignsError}
          createDraftCampaign={this.createDraftCampaign}
          createDraftCampaignsIsLoading={createDraftCampaignsIsLoading}
          createDraftCampaignsError={createDraftCampaignsError}
          createAndSendCampaign={this.createAndSendCampaign}
          createAndSendCampaignsIsLoading={createAndSendCampaignsIsLoading}
          createAndSendDraftCampaignsError={createAndSendCampaignsError}
          updateDraftCampaign={this.updateDraftCampaign}
          updateDraftCampaignsIsLoading={updateDraftCampaignsIsLoading}
          updateDraftCampaignsError={updateDraftCampaignsError}
          addNotification={addNotification}
          hideDrawer={this.hideDrawer}
          showDrawer={this.showDrawer}
        />
      );
    default:
      return false;
  }
};

export { renderModalForm };
